<mat-toolbar  class="sticky">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="center center"  >
        <div fxLayout="row">
        <!-- <h1>Avis <span >Budget</span> Group</h1> -->
        <img [src]=img class="ABGLogo">
        </div>
    </mat-toolbar-row>
</mat-toolbar>
